import React from 'react';

function MicrosoftLogos() {
  return (
    <div className="microsoft-logos">
      <ul>
        <img src={`images/microsoftApps.svg`} />
      </ul>
    </div>
  );
}

export default MicrosoftLogos;


// WEBPACK FOOTER //
// ./frontend/components/MicrosoftLogos.jsx